(function($){

  $.fn.submitAccessCodeForm = function() {
    let form = $(this);
    let domain = form.find('input[name="domain"]').val();
    let code = form.find('input[name="code"]').val();


    $.post(`${window.api_base_url}/api/validate`, {domain, code}, function(response) {
        if(response.valid) {
          setCookie('access_code_validated', 'true', 1);
          closeAccessCodeOverlay();
        } else {
          form.find('.error').removeClass('hidden');
        }
    }, 'json').fail(function(xhr, status, error) {
          // form.find('.error').html(response.responseJSON.message);
          // form.find('.error').removeClass('hidden');
    });
  };

  $(function() {
    if(getCookie('access_code_validated') === 'true') {
      closeAccessCodeOverlay();
    }
    else if($('body').hasClass('has-access-code') && getCookie('access_code_validated') !== 'true') {
      openAccessCodeOverlay();
    }
  })

  $(document).on('submit', '.access-code--form', function(e) {
    e.preventDefault();
    $(this).submitAccessCodeForm();
  });

  function openAccessCodeOverlay() {
    $('body').addClass('has-access-code');
    $('.access-code-overlay--container').removeClass('hidden');
  }

  function closeAccessCodeOverlay() {
    $('body').removeClass('has-access-code');
    $('.access-code-overlay--container').addClass('hidden');
  }
})(jQuery);

